$(function(){

	$(document).foundation();

	/* text resizer */
	var pageContainer = $('.homearticle main:not(.fixedfont)');
	var currentTextSize = parseInt(pageContainer.css('font-size'));
	$('.resizedown').click(function(e){ pageContainer.css('font-size', (--currentTextSize) + 'px'); });
	$('.resizeup').click(function(e){ pageContainer.css('font-size', (++currentTextSize) + 'px'); });

	/* Load pages inside a Modal */
	// tiggers a modal on every link in the popup-footer-nav & on every tag with the data-open attribute
	$('[id^=menu-popup-footer] li a, [data-open]').click(function(e) {
		e.preventDefault();
		$.ajax(this.href).done(function(resp) {
			var body = resp.match(/<body[^>]*>[\s\S]*<\/body>/gi);
			$('#modal').html(body).foundation('open');
			$('#modal').append('<button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button>');
		});
	});

	/* BDC Reminder */
	// Trigger a Modal when the Reminder is activated
	var bdcReminder = $('#bdcReminder[data-show-after]');
	if( bdcReminder.length ) {
		var delay = $(bdcReminder).attr('data-show-after') * 1000;

		var bdcReminderTrigger = window.setInterval(function(){
			var isInViewport = $('.homeform--op').is(':in-viewport');
			if( !isInViewport ) {
				bdcReminder.fadeIn();
				clearInterval(bdcReminderTrigger);
			}
		}, delay);

		// Events to close modal when click outside the modal, on a button or when the escape key is pressed
		$('.bdc__reminder__overlay').click(function(){ bdcReminder.hide(); });
		$('#bdcReminder button').on('click', function(){ bdcReminder.hide(); });
		$(document).keydown(function(e){ if(e.keyCode == 27) bdcReminder.hide(); });
	}

	/**
     * global function to load a page inside a modal (for lp-chat)
     * add <a href="#" onlick="openPopup('/page_url_to_load/')"></a>
    */
	window.openPopup = function(href) {
		var $modal = $('#modal');
		$.ajax(href).done(function(resp) {
			var body = resp.match(/<body[^>]*>[\s\S]*<\/body>/gi);
			$modal.html(body).foundation('open');
			$modal.append('<button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button>');
		});
	};

	/**
	 * stickyBanner
	 * global function to send a GTM Event when a visitor
	 * clicks on the [cta] shortcode
	 */
	window.gtmStickyBanner = function() {
		var dataLayer = window.dataLayer || [];
		dataLayer.push({'event': 'stickyBanner'});
	};

	/* show sticky after some scrolling */
	var sticky = $('aside [data-show-after], footer [data-show-after]');
	if( sticky.length ) {
		var maxheight = $(document).height();
		var toggleSticky = maxheight * ($(sticky).attr('data-show-after') -10) * 0.01 || 0;
		$(document).on("scroll", function(e) {
			var isInViewport = $('.homeform').is(':in-viewport');
			if ( ( ($('body').scrollTop() || $('html').scrollTop()) > toggleSticky )) {
				sticky.addClass('activated');
				if( isInViewport ) {
					// don't show sticky banner if form is in viewport
					$('footer [data-show-after]').removeClass('activated');
				}
			} else {
				if(sticky.parent('.is-at-top.is-anchored').length || $('.single-lp').length){
					sticky.removeClass('activated');
				}
			}
		});
	}

	/* back-to-top button */
	window.addEventListener('scroll', function() {
		var backToTop = document.getElementById('backtotop');
		if( backToTop ) {
			if( window.pageYOffset > 500 ){
				backToTop.classList.add('show');
			} else {
				backToTop.classList.remove('show');
			}
		}
	});

	/* toggle header cart */
	var toggleCart = $('#togglecart');
	if( toggleCart.length ) {
		toggleCart.click(function(e) {
			$('#cart').slideToggle('fast');
		});
	}

	/* toggle ccv tooltip */
	var ccvTooltip = $('span.ccv__tooltip');
	if( ccvTooltip.length ) {
		ccvTooltip.click(function(){
			$('span.ccv__tooltip > div').toggle();
		});
	}

	/* Responsive embedded youtube/vimeo videos */
	// Find all YouTube/Vimeo videos
	var $allVideos = $("iframe[src*='//player.vimeo.com'], iframe[src*='//www.youtube.com']"),
		// The element that is fluid width
		$fluidEl = $(".main");
	// Figure out and save aspect ratio for each video
	$allVideos.each(function() {
		$(this)
		.data('aspectRatio', this.height / this.width)
			// and remove the hard coded width/height
			.removeAttr('height')
			.removeAttr('width');
	});
	// When the window is resized
	$(window).resize(function() {
		var newWidth = $fluidEl.width();
		// Resize all videos according to their own aspect ratio
		$allVideos.each(function() {
			var $el = $(this);
			$el
				.width(newWidth)
				.height(newWidth * $el.data('aspectRatio'));
		});
	// Kick off one resize to fix all videos on page load
	}).resize();


	/* Use PZD when url is unavailable (pzd with KDO_OP1 shortcode) */
	var kdo_op1 = $('.homearticle__pzd [data-shortcode=KDO_OP1] img').attr('src');
	if( kdo_op1 ){
		var print = $('.homearticle__pzd__print');
		if( print.length ){
			// remove and fix broken onclick event
			print.attr('onclick', 'return false;');
			print.click(function(){
				printJS(kdo_op1, 'image');
			});
		}
		var zoom = $('.homearticle__pzd__zoom');
		if( zoom.length ){
			// Add href to the image we want to zoom in
			zoom.attr('href', kdo_op1);
		}
		// Add download button
		$('.homearticle__pzd ul').append('<li><a href="' + kdo_op1 + '" class="homearticle__pzd__download" title="Download" download></a></li>');
	}

	// Rename file name for PZD downloads
	$('a[download]').each(function(){
		var image = $(this).closest('[data-shortcode=pzd]').find('img');
		$(this).attr( 'download', $(image).attr('alt') + ($(this).attr('href')).match(/\.[0-9a-z]+$/i) )
	});

	/* Exclude some email providers (gmx & web.de) */
	var emailExcludeInfo = document.getElementsByClassName('email_exclude_info')[0];
	if( emailExcludeInfo ) {
		var emailInput = document.querySelector('#freeOffer input[type=email]');
		var multiStepContainer = document.getElementsByClassName('ms_container')[0];
		emailInput.addEventListener('input', function(){
			if( isEmailExcluded(this.value) ){
				emailExcludeInfo.classList.add('show');
				if( multiStepContainer ){
					multiStepContainer.style.height = multiStepContainer.offsetHeight + emailExcludeInfo.offsetHeight + 'px';
				}
			} else {
				emailExcludeInfo.classList.remove('show');
				if( MultiStepContainer ){
					multiStepContainer.style.height = multiStepContainer.offsetHeight - emailExcludeInfo.offsetHeight + 'px';
				}
			}
		});
	}
	function isEmailExcluded(email) {
		/* @see https://stackoverflow.com/questions/26388648/email-validation-javascriptregex-but-to-exclude-certain-domains */
		var match = /^\w+[-\.\w]*@(\w+[-\.\w]*?\.\w{2,4})$/.exec(email);
		if (!match) return false;

		var forbiddenDomains = ["gmx.de", "gmx.com", "gmx.at", "gmx.net", "web.de"];
		if (forbiddenDomains.indexOf(match[1].toLowerCase()) >= 0) return true;

		return false;
	}

	/* Wrap dropdowns in a div */
	$('form select').wrap('<div class="trigger"></div>');
});
